export const environment = {
  production: true,
  reportBaseUrl: 'https://dev-pak.deopti.com/DevxReport',
 // reportBaseUrl: 'http://localhost:5000/DevxReport',
  reportActionUrl: '/WebDocumentViewer/Invoke',
  baseUrl: 'https://dev-pak.deopti.com/api/',
  clientPortalBaseUrl: 'https://dehlawi-client-portal-dev-app-cxadejcwbecbbjbg.uaenorth-01.azurewebsites.net/api/',
  //  baseUrl: 'http://3.109.3.54:8080/api/',
// baseUrl: 'https://dehlawi-ftr.azurewebsites.net/api/',
  secret: '',
  version: 'V 2.0.2 (202610141600)'
};
